/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortform_Text_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Shortform Text (e.g. hw)" |
*
* @param {Shortform_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform_text_placeholder = /** @type {((inputs?: Shortform_Text_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortform_Text_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte abrégé (ex. hw)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurzform-Text (z. B. hw)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo abbreviato (ad esempio hw)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Краткий текст (например, домашнее задание)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto abreviado (p. ej., tarea)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("简体文本（例如：作业）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("短縮テキスト（例：hw）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संक्षिप्त पाठ (उदाहरण: गृहकार्य)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto abreviado (ex.: hw)")
	return /** @type {LocalizedString} */ ("Shortform Text (e.g. hw)")
});